<template>
  <div class="modal" @click.stop="closeModal">
    <div class="modal__content" @click.stop>
      <span class="modal__close" @click="closeModal" v-if="!submitted">×</span>
      <template v-if="!submitted">
        <div class="modal__content-title">Мы на связи!</div>
        <div class="modal__content-descr">
          <span
            >оставьте заявку и наши менеджера <br />
            свяжутся с вами в ближайшее время</span
          >
        </div>
        <div class="modal__content-form">
          <form
            id="reg-course"
            class="modal__form"
            @submit.prevent
            @submit="sendFormData"
          >
            <input
              type="text"
              placeholder="Ваше имя*"
              name="modal-name"
              class="form__input"
              required
              autocomplete="off"
              v-model="modalName"
            />
            <input
              type="tel"
              placeholder="Номер телефона*"
              name="modal-tel"
              class="form__input"
              maxlength="17"
              v-model="modalPhone"
              @input="inputNumber"
              @focus="focusNumber"
              @blur="blurNumber"
              required
            />
            <FooterFormDropDown
              @selectRow="selectServiceRow"
              :submitted="submitted"
              :thisIsModal="true"
            ></FooterFormDropDown>
            <input
              type="text"
              placeholder="Telegram @username"
              name="modal-name"
              class="form__input"
              v-model="modalUserName"
            />
            <button
              class="modal-btn"
              onclick="gtag('event', 'click', {'event_category': 'form'}); return true;"
            >
              Оставить заявку
            </button>
          </form>
        </div>
      </template>
      <template v-else>
        <div class="modal__content-title">Ваша заявка отправлена!</div>
        <div class="modal__content-descr">
          Наши менеджеры свяжутся с вами в ближайшее время
        </div>
      </template>
      <img class="modal-img" src="@/assets/images/cosmo.png" alt="" />
    </div>
  </div>
</template>

<script>
import FooterFormDropDown from "@/components/footerFormDropDown.vue";
export default {
  props: {
    formId: String,
  },
  data() {
    return {
      submitted: false,
      modalName: "",
      modalPhone: "",
      modalUserName: "",
      modalSelectService: "Какая услуга вас интересует ?*",
    };
  },
  methods: {
    sendFormData() {
      if (
        this.modalName != "" &&
        this.modalPhone != "" &&
        this.modalSelectService != "Какая услуга вас интересует ?*" &&
        this.modalPhone.length == 17
      ) {
        const formData = new FormData();
        formData.append("name", this.modalName);
        formData.append("username", this.modalUserName);
        formData.append("contact", this.modalPhone);
        formData.append("service", this.modalSelectService);

        this.submitted = true;
        this.$store.dispatch("sendForm", formData).then((response) => {
          this.modalName = "";
          this.modalPhone = "";
          this.modalUserName = "";
          this.modalSelectService = "Какая услуга вас интересует ?*";
          this.submitted = true;
          setTimeout(() => {
            this.$emit("close");
          }, 3000);
        });
      }
    },
    inputNumber(event) {
      if (this.modalPhone.length < 5) this.modalPhone = "+998 ";
      this.modalPhone = this.modalPhone.replace(/[^+|^\d|^\s]/, "");
      const lengths = [4, 7, 11, 14];
      lengths.forEach((item) => {
        if (this.modalPhone.length == item && event.data) {
          this.modalPhone += " ";
        }
      });
    },
    focusNumber() {
      if (this.modalPhone == "") this.modalPhone = "+998 ";
    },
    blurNumber() {
      if (this.modalPhone == "+998 ") this.modalPhone = "";
    },
    closeModal() {
      this.$emit("close");
    },
    selectServiceRow(text) {
      this.modalSelectService = text;
    },
  },
  mounted() {},
  updated() {},
  computed: {},
  watch: {},
  components: { FooterFormDropDown },
};
</script>

<style lang="scss">
@import "@/assets/scss/grid/grid";
.modal {
  width: 100%;
  height: 100%;
  top: 0;
  background: rgba(0, 0, 0, 0.541);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 10;
  &__content {
    @include adaptivWidthLg(542, 346);
    @include adaptivHeightlg(686, 450);
    width: 100%;
    margin: 0 auto;
    @include adaptivPaddinglg(100, 100, 70, 0, 30, 30, 46, 0);
    background: #fff;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    top: 0;
    @media (min-width: 1921px) {
      max-width: 30%;
      min-height: 900px;
      padding: 70px;
    }
    @media (max-width: 768px) {
      @include adaptivWidthmd(760, 310);
      height: 95%;
      @include adaptivPaddingmd(50, 50, 77, 0, 0, 0, 53, 0);
      @include adaptivMarginmd(0, 0, 100, 0, 0, 0, 53, 0);
    }
    .modal-img {
      @include adaptivWidthLg(400, 280);
      @include adaptivHeightlg(220, 140);
      object-fit: contain;
      animation: levitation 20s ease-in-out 0s infinite;
      @media (min-width: 1921px) {
        max-width: 80%;
        height: 70%;
      }
      @media (max-width: 768px) {
        max-width: 100%;
        @include adaptivHeightmd(550, 300);
      }
    }
    @keyframes levitation {
      0% {
        transform: translate(0, 0px);
      }
      10% {
        transform: translate(0, -6px);
      }
      20% {
        transform: translate(0, 6px);
      }
      30% {
        transform: translate(0, -6px);
      }
      40% {
        transform: translate(0, 6px);
      }
      50% {
        transform: translate(0, -6px);
      }
      60% {
        transform: translate(0, 6px);
      }
      70% {
        transform: translate(0, -6px);
      }
      80% {
        transform: translate(0, 6px);
      }
      90% {
        transform: translate(0, -6px);
      }
      100% {
        transform: translate(0, 0px);
      }
    }
    .modal__close {
      position: absolute;
      top: 1%;
      right: 4%;
      @include adaptiv-fontlg(70, 40);
      color: #2b2a29;
      cursor: pointer;
      user-select: none;
      @media (min-width: 1921px) {
        font-size: 50px;
      }
      @media (max-width: 768px) {
        @include adaptiv-fontmd(60, 30);
        top: 4%;
        right: 8%;
        transform: translate(50%, -50%);
      }
    }

    &-title {
      font-family: "Helvetica";
      @include adaptiv-fontlg(42, 28);
      @include adaptiv-lineHeightlg(42, 28);
      text-align: center;
      color: #303030;
      text-transform: uppercase;
      @include adaptivMarginlg(0, 0, 0, 23, 0, 0, 0, 8);
      @media (max-width: 768px) {
        @include adaptiv-fontmd(60, 28);
        @include adaptiv-lineHeightmd(60, 28);
        @include adaptivMarginmd(0, 0, 0, 24, 0, 0, 0, 12);
        text-align: center;
      }
      @media (min-width: 1921px) {
        font-size: 50px;
      }
    }
    &-descr {
      display: block;
      font-family: "Helvetica-normal";
      @include adaptiv-fontlg(15, 8);
      @include adaptiv-lineHeightlg(16, 12);
      text-align: center;
      color: #2b2a29;
      @include adaptivMarginlg(0, 0, 0, 30, 0, 0, 0, 20);
      text-transform: uppercase;
      @media (max-width: 768px) {
        @include adaptiv-fontmd(20, 12);
        @include adaptiv-lineHeightmd(24, 14);
        @include adaptivMarginmd(0, 0, 0, 73, 10, 10, 0, 33);
      }
      @media (min-width: 1921px) {
        font-size: 22px;
        line-height: 24px;
      }
    }
    &-form {
      @include adaptivWidthLg(444, 237);
      width: 100%;
      justify-content: center;
      display: flex;
      flex-direction: column;
      @media (max-width: 768px) {
        width: 100%;
        @include adaptivWidthmd(600, 280);
      }
      .logo {
        @include adaptivWidthLg(106, 61);
        @include adaptivHeightlg(27, 16);
        margin: 20px auto 14px;
        @media (max-width: 768px) {
          @include adaptivWidthmd(220, 95);
          @include adaptivHeightmd(40, 25);
          margin: 33px auto 28px;
        }
        @media (min-width: 1921px) {
          margin: 33px auto 35px;
        }
      }
      .modal-btn {
        position: relative;
        overflow: hidden;

        display: flex;
        align-items: center;
        justify-content: center;
        @include adaptivWidthLg(444, 237);
        width: 100%;
        @include adaptivHeightlg(49, 32);
        background: #2b2a29;
        color: #fff;
        @include adaptiv-fontlg(15, 11);
        @include adaptiv-lineHeightlg(15, 11);
        font-family: "Helvetica-normal";
        margin: 0 auto;
        .button-link {
          color: #303030;
        }
        &::after {
          content: "";
          display: block;
          width: 30px;
          height: 250px;
          margin-left: 50px;
          background: #fff;
          background: linear-gradient(
            to bottom,
            rgba(255, 255, 255, 0.2) 0%,
            rgba(255, 255, 255, 0.3) 50%,
            rgba(255, 255, 255, 0.2) 100%
          );

          backdrop-filter: blur(5px);
          left: -40px;
          top: -80px;
          z-index: 1;
          transform: rotate(45deg);
          position: absolute;
          animation: movingFlare 4s ease-in-out 0.05s infinite;
        }

        @keyframes movingFlare {
          0% {
            left: -30px;
            margin-left: 0px;
          }
          30% {
            left: 110%;
            margin-left: 80px;
          }
          100% {
            left: 110%;
            margin-left: 80px;
          }
        }
        @media (max-width: 768px) {
          @include adaptivWidthmd(600, 280);
          @include adaptivHeightmd(80, 40);
          @include adaptiv-fontmd(25, 15);
          @include adaptiv-lineHeightlg(22, 19);
        }
        @media (min-width: 1921px) {
          font-size: 20px;
        }
      }
      .form__input {
        width: 100%;
        @include adaptivHeightlg(49, 32);
        display: block;
        font-family: "Helvetica-thin";
        font-style: normal;
        font-weight: 300;
        color: #8e8e8e;
        @include adaptiv-fontlg(15, 8);
        @include adaptiv-lineHeightlg(18, 10);
        @include adaptivMarginlg(0, 0, 0, 12, 0, 0, 0, 6);
        @include adaptivPaddinglg(25, 25, 0, 0, 10, 10, 0, 0);
        border: none;
        border-radius: 0px;
        background: #eeeded;
        @media (max-width: 768px) {
          @include adaptivMarginmd(0, 0, 0, 8, 0, 0, 0, 6);
          @include adaptiv-fontmd(25, 15);
          @include adaptiv-lineHeightmd(25, 15);
          @include adaptivHeightmd(80, 40);
          @include adaptivPaddingmd(15, 15, 0, 0, 10, 10, 0, 0);
        }
      }
    }
  }
}
</style>
